import { GetProcessDocument, ProcessFragment } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type Process = ProcessFragment | undefined

export const useProcess = (id: string) => {
  const { data, loading } = useQuery(GetProcessDocument, {
    variables: { id: id },
  })

  const process = data?.processes.process as Process

  return {
    loading: !process || loading,
    process,
  }
}
